import { render, staticRenderFns } from "./ContentButtons.vue?vue&type=template&id=fe22ebfc&"
import script from "./ContentButtons.vue?vue&type=script&lang=js&"
export * from "./ContentButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports